import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';

export interface CartState {
  user_id: string;
  cartItemsCount: number;
}

const initialState: CartState = {
  // Lấy user_id từ localStorage nếu có, nếu chưa thì để rỗng
  user_id: localStorage.getItem('user_id') || '',
  cartItemsCount: 0
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setUserId: (state, action: PayloadAction<string>) => {
      state.user_id = action.payload;
      // Lưu xuống localStorage luôn để khi reload vẫn còn
      localStorage.setItem('user_id', action.payload);
    },
    clearUserId: (state) => {
      state.user_id = '';
      state.cartItemsCount = 0;
      localStorage.removeItem('user_id');
    },
    setCartItemsCount: (state, action: PayloadAction<number>) => {
      state.cartItemsCount = action.payload;
    },
    incrementCartItemsCount: (state, action: PayloadAction<number>) => {
      state.cartItemsCount += action.payload;
    },
    decrementCartItemsCount: (state, action: PayloadAction<number>) => {
      state.cartItemsCount = Math.max(0, state.cartItemsCount - action.payload);
    }
  }
});

export const { setUserId, clearUserId, setCartItemsCount, incrementCartItemsCount, decrementCartItemsCount } = cartSlice.actions;

// Selector
export const visitorId = (state: RootState) => state.cart.user_id;
export const selectCartItemsCount = (state: RootState) => state.cart.cartItemsCount;

export default cartSlice.reducer;
